import {Storage} from '@/utils/common';
const user = {
  namespaced: true,
  state: {
    userInfo: Storage.get('userInfo') || {},
    auth: Storage.get('auth') || {
      btn: []
    }
  },
  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
      Storage.set('userInfo', userInfo);
    },
    SET_AUTH: (state, auth) => {
      state.auth = auth;
      Storage.set('auth', auth);
    }
  }
};
export default user;
